package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ProjectStatusQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    project_id: String,
    name: String,
    color: String,
    order_index: Long,
    is_terminal: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_480_862_920, arrayOf("projectStatus"), driver, "ProjectStatus.sq",
      "selectAll",
      "SELECT projectStatus.id, projectStatus.project_id, projectStatus.name, projectStatus.color, projectStatus.order_index, projectStatus.is_terminal, projectStatus.created_at, projectStatus.updated_at, projectStatus.is_deleted, projectStatus.deleted_at, projectStatus.synced_at FROM projectStatus WHERE is_deleted = 0 ORDER BY project_id, order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectAll(): Query<ProjectStatus> = selectAll { id, project_id, name, color,
      order_index, is_terminal, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    ProjectStatus(
      id,
      project_id,
      name,
      color,
      order_index,
      is_terminal,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByProject(project_id: String, mapper: (
    id: String,
    project_id: String,
    name: String,
    color: String,
    order_index: Long,
    is_terminal: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByProjectQuery(project_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByProject(project_id: String): Query<ProjectStatus> =
      selectByProject(project_id) { id, project_id_, name, color, order_index, is_terminal,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    ProjectStatus(
      id,
      project_id_,
      name,
      color,
      order_index,
      is_terminal,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    project_id: String,
    name: String,
    color: String,
    order_index: Long,
    is_terminal: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectById(id: String): Query<ProjectStatus> = selectById(id) { id_, project_id, name,
      color, order_index, is_terminal, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    ProjectStatus(
      id_,
      project_id,
      name,
      color,
      order_index,
      is_terminal,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> terminalForProject(project_id: String, mapper: (
    id: String,
    project_id: String,
    name: String,
    color: String,
    order_index: Long,
    is_terminal: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = TerminalForProjectQuery(project_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun terminalForProject(project_id: String): Query<ProjectStatus> =
      terminalForProject(project_id) { id, project_id_, name, color, order_index, is_terminal,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    ProjectStatus(
      id,
      project_id_,
      name,
      color,
      order_index,
      is_terminal,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    project_id: String,
    name: String,
    color: String,
    order_index: Long,
    is_terminal: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_472_400_471, arrayOf("projectStatus"), driver, "ProjectStatus.sq",
      "selectDirty",
      "SELECT projectStatus.id, projectStatus.project_id, projectStatus.name, projectStatus.color, projectStatus.order_index, projectStatus.is_terminal, projectStatus.created_at, projectStatus.updated_at, projectStatus.is_deleted, projectStatus.deleted_at, projectStatus.synced_at FROM projectStatus WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectDirty(): Query<ProjectStatus> = selectDirty { id, project_id, name, color,
      order_index, is_terminal, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    ProjectStatus(
      id,
      project_id,
      name,
      color,
      order_index,
      is_terminal,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    project_id: String,
    name: String,
    color: String,
    order_index: Long,
    is_terminal: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByIdAnyState(id: String): Query<ProjectStatus> = selectByIdAnyState(id) { id_,
      project_id, name, color, order_index, is_terminal, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    ProjectStatus(
      id_,
      project_id,
      name,
      color,
      order_index,
      is_terminal,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    project_id: String,
    name: String,
    color: String,
    order_index: Long,
    is_terminal: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(601_616_230, """
        |INSERT INTO projectStatus(id, project_id, name, color, order_index, is_terminal, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, project_id)
          bindString(2, name)
          bindString(3, color)
          bindLong(4, order_index)
          bindLong(5, is_terminal)
          bindLong(6, created_at)
          bindLong(7, updated_at)
        }
    notifyQueries(601_616_230) { emit ->
      emit("projectStatus")
    }
  }

  public fun update(
    name: String,
    color: String,
    order_index: Long,
    is_terminal: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(946_562_422, """
        |UPDATE projectStatus
        |SET name = ?, color = ?, order_index = ?, is_terminal = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 6) {
          bindString(0, name)
          bindString(1, color)
          bindLong(2, order_index)
          bindLong(3, is_terminal)
          bindLong(4, updated_at)
          bindString(5, id)
        }
    notifyQueries(946_562_422) { emit ->
      emit("projectStatus")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_896_141_662,
        """UPDATE projectStatus SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_896_141_662) { emit ->
      emit("projectStatus")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(610_614_145,
        """UPDATE projectStatus SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(610_614_145) { emit ->
      emit("projectStatus")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-2_076_203_869, """DELETE FROM projectStatus WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-2_076_203_869) { emit ->
      emit("projectStatus")
      emit("task")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-693_248_044,
        """UPDATE projectStatus SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-693_248_044) { emit ->
      emit("projectStatus")
    }
  }

  private inner class SelectByProjectQuery<out T : Any>(
    public val project_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("projectStatus", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("projectStatus", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-552_983_783,
        """SELECT projectStatus.id, projectStatus.project_id, projectStatus.name, projectStatus.color, projectStatus.order_index, projectStatus.is_terminal, projectStatus.created_at, projectStatus.updated_at, projectStatus.is_deleted, projectStatus.deleted_at, projectStatus.synced_at FROM projectStatus WHERE project_id = ? AND is_deleted = 0 ORDER BY order_index""",
        mapper, 1) {
      bindString(0, project_id)
    }

    override fun toString(): String = "ProjectStatus.sq:selectByProject"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("projectStatus", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("projectStatus", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_337_931_035,
        """SELECT projectStatus.id, projectStatus.project_id, projectStatus.name, projectStatus.color, projectStatus.order_index, projectStatus.is_terminal, projectStatus.created_at, projectStatus.updated_at, projectStatus.is_deleted, projectStatus.deleted_at, projectStatus.synced_at FROM projectStatus WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ProjectStatus.sq:selectById"
  }

  private inner class TerminalForProjectQuery<out T : Any>(
    public val project_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("projectStatus", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("projectStatus", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-202_103_079,
        """SELECT projectStatus.id, projectStatus.project_id, projectStatus.name, projectStatus.color, projectStatus.order_index, projectStatus.is_terminal, projectStatus.created_at, projectStatus.updated_at, projectStatus.is_deleted, projectStatus.deleted_at, projectStatus.synced_at FROM projectStatus WHERE project_id = ? AND is_terminal = 1 AND is_deleted = 0 ORDER BY order_index LIMIT 1""",
        mapper, 1) {
      bindString(0, project_id)
    }

    override fun toString(): String = "ProjectStatus.sq:terminalForProject"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("projectStatus", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("projectStatus", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-582_091_712,
        """SELECT projectStatus.id, projectStatus.project_id, projectStatus.name, projectStatus.color, projectStatus.order_index, projectStatus.is_terminal, projectStatus.created_at, projectStatus.updated_at, projectStatus.is_deleted, projectStatus.deleted_at, projectStatus.synced_at FROM projectStatus WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ProjectStatus.sq:selectByIdAnyState"
  }
}
